import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { Button, Dropdown, Popup } from 'semantic-ui-react'
import StaticInput from './StaticInput'

import './GenericSelect.css'

class GenericSelect extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      selected: props.selected || null
    }

    // Bind events
    this.onChangeSelect = this.onChangeSelect.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    // Bubble local change to parent
    if (prevState.selected !== this.state.selected) {
      if (_.isFunction(this.props.onChange)) {
        this.props.onChange(this.state.selected)
      }
    }

    // Bubble parent change to local
    if (prevProps.selected !== this.props.selected) {
      this.setState({
        selected: this.props.selected
      })
    }
  }

  onChangeSelect(event, data) {
    const selected = data.value
    this.setState({
      selected
    })
  }

  render() {
    const { label, loading, options, selected, onChange, error, canSearch, reducedPadding, useAddBtn, ...props } = this.props
    const classNames = [];
    if (reducedPadding) {
      classNames.push('reduced-padding')
    }
    if (useAddBtn) {
      classNames.push('select-flex')
    }
    const attributes = _.extend(
      {
        selection: true,
        selectOnNavigation: false,
        selectOnBlur: false,
        placeholder: loading ? 'Chargement...' : 'Choisir...',
        loading: loading || false,
        options: _.map(
          options,
          (option) => (_.extend(
            {
              key: option.key,
              value: option.key,
              text: option.value
            },
            canSearch
              ? {
                  searchValue: option.searchValue || String(option.value)
                }
              : {}
          ))
        ),
        value: this.state.selected,
        onChange: this.onChangeSelect
      },
      canSearch
        ? {
            search: (options, query) => {
              const regexp = new RegExp(query, 'i')
              return _.filter(
                _.uniq(
                  options,
                  (opt) => (opt.key)
                ),
                (opt) => (opt.searchValue.search(regexp) >= 0)
              )
            },
            noResultsMessage: 'Aucun résultat.'
          }
        : {},
      classNames.length
        ? {
            className: classNames.join(' ')
          }
        : {},
      { ...props }
    )
    return (
      <StaticInput
        label={label}
        content={
          useAddBtn
            ? <div
                className='select-btn-add-wrapper'
              >
                <Dropdown
                  {...attributes}
                />
                {
                  useAddBtn.disabledMessage
                    ? <Popup
                        trigger={
                          <div>
                            <Button
                              className='btn-add-gestmat'
                              compact={true}
                              icon='plus'
                              color='red'
                              disabled={true}
                            />
                          </div>
                        }
                        hideOnScroll={true}
                        inverted={true}
                        on='hover'
                        position='top center'
                      >
                        {useAddBtn.disabledMessage}
                      </Popup>
                    : <Button
                        className='btn-add-gestmat'
                        compact={true}
                        icon='plus'
                        color='green'
                        type='button'
                        onClick={useAddBtn.onClick}
                        disabled={_.isNull(this.state.selected)}
                      />
                }
              </div>
            : <Dropdown
                {...attributes}
              />
        }
        error={error}
      />
    )
  }
}

GenericSelect.propTypes = {
  label: PropTypes.string, // if missing, rendered without Form structure
  loading: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.number.isRequired
      ]).isRequired,
      value: PropTypes.node.isRequired,
      searchValue: PropTypes.string
    }).isRequired
  ).isRequired,
  selected: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  canSearch: PropTypes.bool,
  reducedPadding: PropTypes.bool,
  useAddBtn: PropTypes.shape({
    onClick: PropTypes.func.isRequired,
    disabledMessage: PropTypes.string
  })
}

export default GenericSelect



// WEBPACK FOOTER //
// ./src/components/elements/forms/GenericSelect.js